import gql from "graphql-tag";

export const SYNC_COMPANY_CREATION_TO_HUBSPOT = gql`
  mutation syncCompanyCreationToHubspot($companyCreationId: String!) {
    syncCompanyCreationToHubspot(companyCreationId: $companyCreationId) {
      feedback
    }
  }
`;
